var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-msg"},[_c('img',{staticClass:"not-msg-img",attrs:{"src":require("@/assets/images/icons/nothing.png")}}),_c('div',{staticClass:"not-msg-text"},[_vm._v("暂无相关信息")])])
}]

export { render, staticRenderFns }